import React, { useEffect } from "react";
// 引入 AOS 動畫庫與其樣式，用以實現頁面元素的進場動畫效果
import Aos from "aos";
import "aos/dist/aos.css";
// 引入本元件的 CSS 樣式檔
import "./signature.css";
// 引入 React Router 的 Link 元件，用於頁面導覽
import { Link } from "react-router-dom";

// 引入圖示（定位圖示）
import { HiOutlineLocationMarker } from "react-icons/hi";

// 引入圖片資源
import img6 from "../../Assets/signImg/img6.jpeg";

/*
  Data 陣列：
  - 儲存本行程頁面所需的主要資訊，包括圖片來源、行程標題、地點、執行機構、費用與描述等。
  - 若需擴充更多行程項目，請於此陣列中增加對應物件即可。
*/
const Data = [
  {
    id: 6,
    imgSrc: img6,
    destTitle: "醫者朝聖 - 世界頂級醫學探索之路",
    location: "🇺🇸 · 美國 · 東部",
    grade: "專科，大學",
    fees: "3900 美元",
    description:
      "世界頂級的醫學院、診所、研究院、專科醫療機構、創業公司、百年醫藥公司、新興醫療產業，密集集中在美國的東部。是全世界醫科學生、醫療從業者「朝聖」的地區。",
  },
];

/*
  Signature6 元件：
  - 利用 useEffect 初始化 AOS 動畫庫，設定動畫持續時間為 2000 毫秒。
  - 透過 Data 陣列動態渲染行程資訊，包含行程特色、參團資訊、參考行程等詳細資料，
    並以表格方式呈現各項內容。
  - 提供返回首頁按鈕供使用者導覽。
  - 全部文字內容皆已依臺灣用語習慣轉為繁體中文。
*/
export default function Signature6() {
  // 在元件掛載時初始化 AOS 動畫效果
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="signMain signContainer signSection">
      {/* 頁面標題區塊 */}
      <div className="signSecTitle">
        <h3 data-aos="fade-right" className="signTitle">
          醫 者 朝 聖 - 世 界 頂 級 醫 學 探 索 之 路
        </h3>
        <button className="signHomeBtn">
          <Link to="/" className="signHomeBtnLink">
            返回首頁
          </Link>
        </button>
      </div>

      {/* 主要內容區：採用 Grid 佈局呈現行程資訊 */}
      <div className="signSecContent signGrid">
        {Data.map(({ id, imgSrc, destTitle, location, company, fees, description }) => {
          return (
            <div key={id} data-aos="fade-up" className="signSingleDestination">
              {/* 左側文字資訊區 */}
              <div className="signCardInfo">
                <h4 className="signDestTitle">{destTitle}</h4>
                {/* 地點資訊，搭配定位圖示 */}
                <span className="signContinent signFlex">
                  <HiOutlineLocationMarker className="icon" />
                  <span className="signName">{location}</span>
                </span>

                {/* 行程詳細說明區 */}
                <div className="signFees signFlex">
                  <div className="signGrade">
                    <span>
                      執行機構：{company}
                      <br /><br />
                      <small>⭐️ 行 程 精 華 ⭐️</small>
                      <br /><br />
                    </span>
                  </div>
                  <div>
                    <h6>{description}</h6>
                    <br />
                    {/* 表格：展示活動亮點等細節 */}
                    <table width="80%">
                      <thead>
                        <tr>
                          <th width="20%"></th>
                          <th width="10%"></th>
                          <th width="70%"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>活動亮點</td>
                          <td></td>
                          <td>
                            私立學校夏令營：體育、文藝、科學、戶外；<br />
                            課後活動：博物館、森林公園、度假屋、<br />
                            採購、品酒、社區考察
                          </td>
                        </tr>
                        <tr>
                          <td>沉浸式體驗</td>
                          <td></td>
                          <td>
                            入學加拿大本土私校，純英文環境，完全融入當地孩子的暑期生活；
                          </td>
                        </tr>
                        <tr>
                          <td>家長陪同</td>
                          <td></td>
                          <td>
                            全程親子陪同，增進學生與家長的親密關係
                          </td>
                        </tr>
                        <tr>
                          <td>課後活動</td>
                          <td></td>
                          <td>
                            豐富的課後本土活動，體驗加拿大純正的市民生活
                          </td>
                        </tr>
                        <tr>
                          <td>未來規劃</td>
                          <td></td>
                          <td>
                            全面考察加拿大的教育、生活、社會，為學生未來國際化學習提供規劃
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* 參團資訊區塊 */}
                <div className="signFees signFlex">
                  <div className="signGrade">
                    <span>
                      <small>⭐️ 參 團 資 訊 ⭐️</small>
                    </span>
                    <br /><br />
                  </div>
                  <br />
                  <table width="70%">
                    <thead>
                      <tr>
                        <th width="20%"></th>
                        <th width="10%"></th>
                        <th width="70%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>招生對象</td>
                        <td></td>
                        <td>4 歲-14 歲中小學生</td>
                      </tr>
                      <tr>
                        <td>時 間</td>
                        <td></td>
                        <td>2024 年 6 月-7 月</td>
                      </tr>
                      <tr>
                        <td>時 長</td>
                        <td></td>
                        <td>14 天</td>
                      </tr>
                      <tr>
                        <td>地 點</td>
                        <td></td>
                        <td>加拿大多倫多市</td>
                      </tr>
                      <tr>
                        <td>費 用 包 含</td>
                        <td></td>
                        <td>
                          私立學校夏令營團費、在加拿大期間的餐飲費用、住宿費用、交通費用、門票及相關費用、
                          簽證申請服務、留學規劃諮詢服務、留學申請服務
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* 參考行程區塊 */}
                <div className="signFees">
                  <div className="signGrade">
                    <span>
                      <small>⭐️ 參 考 行 程 ⭐️</small>
                    </span>
                    <br /><br />
                  </div>
                  <br />
                  <h6>行程範例</h6>
                  <p>
                    實際活動內容可能會有前後調整；或被相近內容替代；夏令營正式開始前一週確定具體行程。
                  </p>
                  <br />
                  <table width="100%">
                    <thead>
                      <tr>
                        <th width="5%">日期</th>
                        <th width="12.5%">上午</th>
                        <th width="32.5%">活動</th>
                        <th width="5%"></th>
                        <th width="12.5%">下午</th>
                        <th width="32.5%">活動</th>
                      </tr>
                      <br />
                    </thead>
                    <tbody>
                      <tr>
                        <td>週六</td>
                        <td>出發</td>
                        <td>抵達</td>
                        <td></td>
                        <td>入住</td>
                        <td>休整</td>
                      </tr>
                      <br /><br />
                      <tr>
                        <td>週日</td>
                        <td>曼哈頓自由行</td>
                        <td>曼哈頓自由行</td>
                        <td></td>
                        <td>曼哈頓自由行</td>
                        <td>曼哈頓自由行</td>
                      </tr>
                      <br /><br />
                      <tr>
                        <td>週一</td>
                        <td>私校夏令營報到</td>
                        <td>市民活動</td>
                        <td></td>
                        <td>私校夏令營第一日課程</td>
                        <td>課後活動</td>
                      </tr>
                      <tr>
                        <td>週二</td>
                        <td>私校夏令營第二日</td>
                        <td>加拿大多倫多市參訪</td>
                        <td></td>
                        <td>文化講座</td>
                        <td>活動體驗</td>
                      </tr>
                      <tr>
                        <td>週三</td>
                        <td>私校夏令營第三日</td>
                        <td>校內學習交流</td>
                        <td></td>
                        <td>專題討論</td>
                        <td>社會活動</td>
                      </tr>
                      <tr>
                        <td>週四</td>
                        <td>私校夏令營第四日</td>
                        <td>戶外探索</td>
                        <td></td>
                        <td>博物館參觀</td>
                        <td>學習分享</td>
                      </tr>
                      <tr>
                        <td>週五</td>
                        <td>私校夏令營第五日</td>
                        <td>遠足、徒步</td>
                        <td></td>
                        <td>體驗活動</td>
                        <td>團體討論</td>
                      </tr>
                      <br /><br />
                    </tbody>
                  </table>
                </div>

                {/* 預售價格與報名按鈕區 */}
                <div className="signPrice">
                  <h5>預售價格 ：{fees}</h5>
                </div>
                <button className="signBtn signFees">
                  <Link to={"/formReg"} target="_blank">
                    <h4>
                      ⭐️ ⭐️ ⭐️ 預 約 報 名 - 搶 先 卡 位 ⭐️ ⭐️ ⭐️
                    </h4>
                  </Link>
                </button>
              </div>

              {/* 右側圖片區塊 */}
              <div className="signImageDiv">
                <img src={imgSrc} alt={destTitle} />
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}